import React from 'react';
import { FieldForm } from '../course_works/FieldForm';
import { SubmitFieldState } from '../../../../commonv3/types/course_works';
import './ReviewFieldForm.module.scss';

type Props = {
  id: string;
  fields: SubmitFieldState[];
};

export const ReviewFieldForm = ({ id, fields }: Props) => {
  return (
    <div styleName="wrapper">
      <div id={id}>
        {fields.map((field) => (
          <FieldForm key={field.definition.uid} field={field} />
        ))}
      </div>
    </div>
  );
};
